import $ from "jquery";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { hexToHsl } from "@bd-utils/hexToHSL";
import { getHueRotation } from "@bd-utils/getHueRotation";
import {
    getRoomAvailableCards,
    getRoomCurrentCard,
    getRoomReflectionData,
    getRoomUsedCards,
    maybeUpdateRoomStatus,
    removeSelectedCase,
    updateRoomCards,
} from "@bd-core/firebase-actions";
import fb from "@bd-core/firebase";
import { getLeader, getPlayers } from "@bd-stores/game-progress";
import GameLogic from "@bd-core/game-logic";

export class RoomCaseScenario extends BD_Component {
    constructor() {
        super();

        this.id = "case_scenario";
        this.templateID = "case_scenario-template";
        this._videoEndedHandler = this.onVideoEnded.bind(this);

        this.elms = {
            playCardBtn: ".js-play-card-btn",
            useCardBtn: ".js-use-card-btn",
            cardTitle: ".card-title",
            deck: ".caseScenario__deck img",
            deckTopCard: ".caseScenario__deck .deck__top-card",
            playingCard: ".caseScenario__card",
            flipButton: ".caseScenario__card_flip",
            headerLeader: ".js-header-leader",
            headerTitle: ".js-header-title",
            headerSubtitle: ".js-header-subtitle",
            showMoreUsedCards: ".caseScenario__breadcrumb_show",
            caseScenario: ".caseScenario",
            caseScenarioOverlay: ".caseScenario__overlay",
            cardButtonIcon: ".caseScenario__overlay__btn svg path",
            templateStartingCard:
                ".caseScenario__card.is-template.starting-card",
            templatePlayingCardOption:
                ".caseScenario__card.is-template.playing-card.is-option",
            templatePlayingCardText:
                ".caseScenario__card.is-template.playing-card.is-text",
            templatePlayingCardCharacter:
                ".caseScenario__card.is-template.playing-card.is-character",
            templateScoreCard: ".caseScenario__card.is-template.is-score",
            templateReflectionCard:
                ".caseScenario__card.is-template.is-reflection",
            templateStartingCardButton: ".caseScenario__card__button",
            submitCard: ".caseScenario__overlay__btn.option",
            closeCard: ".caseScenario__overlay__btn",
            frontCard: ".caseScenario__card--front",
            backCard: ".caseScenario__card--back",
            frontCardNumber: ".caseScenario__card_number",
            frontCardTitle: ".caseScenario__card_title span",
            backCardTitle: ".caseScenario__card_heading h4",
            backCardDescription: ".caseScenario__card_description",
            backCardTagLine: ".card_effect",
            backCardCharacterName: ".caseScenario__card_character__name",
            backCardCharacterProductivityNumber:
                ".caseScenario__card_character__productivity",
            backCardCharacterImage: ".caseScenario__card_character__image",
            backCardCharacterGrid: ".caseScenario__card_character__grid",
            backCardCharacterFeel: ".caseScenario__card_character__feel img",
            backCardTextAct: ".text_act",
            backCardOptionList: ".options_list",
            backCardOptionListItem: ".options_list__item",
            breadcrumbCharacterShow: ".js-show-card",
            breadcrumbCharacterHide: ".js-hide-card",
            breadcrumbItem: ".breadcrumb_item",
            breadcrumbItems: ".caseScenario__breadcrumb_items",
            breadcrumbItemTemplate: ".breadcrumb_item.is-template",
            breadcrumbOverlayButton: ".caseScenario__curtain__btn",
            drawerItem: ".drawer-item",
            drawerItems: ".caseScenario__drawer__items",
            drawerItemTemplate: ".drawer-item.is-template",
            drawerBtn: ".js-close-drawer",
            scoreCardTop: ".caseScenario__card__score--top",
            scoreCardBottom: ".caseScenario__card__score--bottom",
            scoreCardTitle: ".score-title",
            reflectionCardTop: ".caseScenario__card__reflection--top",
            reflectionCardBottom: ".caseScenario__card__reflection--bottom",
            reflectionCardQuestion: ".reflection-question",
            finishCaseBtn: ".js-finish-case-btn",
            curtainCard: ".caseScenario__curtain__card",
            video: ".caseScenario__card_character__video",
            breadcrumbCard: ".breadcrumb-card",
            breadcrumbContainer: ".caseScenario__breadcrumb",
            breadcrumbCharacter: ".caseScenario__breadcrumb_character",
            leaveCaseBtn: ".js-leave-case-btn",
            leavePopup: ".caseScenario__leave-popup",
            leavePopupClose: ".js-leave-popup-close",
            leavePopupNo: ".js-leave-popup-no",
            leavePopupYes: ".js-leave-popup-yes",
        };

        this._events = this.getEvents();
        this.fbListeners = [];

        this._roomData = {};
        this._data = {};
        this._cards = [];
        this._currentCard = {};
        this._availableCards = [];
        this._usedCards = [];
        this._onReflectionMode = false;
        this._latestUsedCards = [];
        this._startingCard = {};
        this._isFinished = false;
        this._isStartingCard = false;
        this._leader = 0;
        this._isLeader = false;
        this._lastUsedCardPosition = null;
        this._isFromStartingCardButton = false;
        this._phases = {};
        this._currentPhase = 1;
        this._totalPhases = 0;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.playCardBtn,
                handler: this.onPlayCard,
            },
            {
                event: "click",
                selector: elms.useCardBtn,
                handler: this.onUseCard,
            },
            {
                event: "click",
                selector: elms.playingCard,
                handler: this.onClickCard,
            },
            {
                event: "click",
                selector: elms.flipButton,
                handler: this.onFlipCard,
            },
            {
                event: "click",
                selector: elms.breadcrumbItem,
                handler: this.onClickBreadcrumbItem,
            },
            {
                event: "click",
                selector: elms.breadcrumbOverlayButton,
                handler: this.onCloseBreadcrumbView,
            },
            {
                event: "click",
                selector: elms.templateStartingCardButton,
                handler: this.onUseCard,
            },
            {
                event: "click",
                selector: elms.closeCard,
                handler: this.onCloseCard,
            },
            {
                event: "click",
                selector: elms.submitCard,
                handler: this.onSubmitCard,
            },
            {
                event: "click",
                selector: elms.backCardOptionListItem,
                handler: this.onOptionClick,
            },
            {
                event: "click",
                selector: elms.finishCaseBtn,
                handler: this.onFinishCase,
            },
            {
                event: "click",
                selector: elms.breadcrumbCharacterShow,
                handler: this.onShowBreadcrumbCharacter,
            },
            {
                event: "click",
                selector: elms.breadcrumbCharacterHide,
                handler: this.onHideBreadcrumbCharacter,
            },
            {
                event: "ended",
                selector: elms.video,
                handler: this._videoEndedHandler,
            },
            {
                event: "click",
                selector: elms.showMoreUsedCards,
                handler: this.onShowMoreUsedCards,
            },
            {
                event: "click",
                selector: elms.drawerItem,
                handler: this.onClickDrawerItem,
            },
            {
                event: "click",
                selector: elms.drawerBtn,
                handler: this.onCloseDrawer,
            },
            {
                event: "click",
                selector: elms.leaveCaseBtn,
                handler: this.onLeaveCase,
            },
            {
                event: "click",
                selector: elms.leavePopupClose,
                handler: this.onCloseLeavePopup,
            },
            {
                event: "click",
                selector: elms.leavePopupNo,
                handler: this.onCloseLeavePopup,
            },
            {
                event: "click",
                selector: elms.leavePopupYes,
                handler: this.onConfirmLeaveCase,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.listenTeamAttributes();
        this.listenRoomCards();
    }

    getModifiedData() {
        const modified = { ...this._data };

        this._cards = CONFIG.game.cards;
        this._roomData = CONFIG.game.rooms.find(
            (room) => room.id === this.roomId,
        );
        this._startingCard = this._cards[this._roomData.room_starting_card];

        const cardsArray = Object.values(this._cards);
        this._phases = {};
        if (this._roomData.room && Array.isArray(this._roomData.room.phases)) {
            this._roomData.room.phases.forEach((phaseId) => {
                this._phases[phaseId] = cardsArray
                    .filter((card) => card.phase === phaseId)
                    .map((card) => card.id);
            });
        }
        this._totalPhases = Object.keys(this._phases).length;

        const modifiedData = {
            ...modified,
            cards: this._cards,
            room: this._roomData,
            startingCard: this._startingCard,
            phases: this._phases,
            currentPhase: this._currentPhase,
            totalPhases: this._totalPhases,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        this.renderLeaveCasePopup();
    }

    setGameState() {
        const roomID = this.roomId;

        this.maybeTeamAttributesChange();
        this._currentCard = {};
        this.updateProgressBar();

        // setting color of deck
        const deckColor = "#ef3340";
        const targetColor = this._roomData.room.background_color;

        if (targetColor) {
            $(this.elms.deckTopCard).css("background-color", targetColor);

            const hueRotation = getHueRotation(deckColor, targetColor);
            $(this.elms.deck).css("filter", `hue-rotate(${hueRotation}deg)`);
        }

        // setting svg color of card button "Continue"
        $(this.elms.cardButtonIcon).attr("stroke", "#ffffff");

        this._isFinished = false;
        getRoomReflectionData(roomID).then((data) => {
            const reflectionCards = data.reflectionCards.val();
            const flippedReflectionCards = data.flippedReflectionCards.val();
            const reflectionCardsArray = reflectionCards
                ? Object.entries(reflectionCards).map(([key, value]) => ({
                      key,
                      ...value,
                  }))
                : [];

            const reflectionCardData = reflectionCardsArray.map((card) => {
                return this._cards[card.id];
            });

            this._usedCards = [];
            this._latestUsedCards = [];
            getRoomUsedCards(roomID).then((data) => {
                const usedCards = data.val();

                let usedCardsArray = usedCards
                    ? Object.entries(usedCards).map(([key, value]) => ({
                          key,
                          ...value,
                      }))
                    : [];

                if (usedCardsArray && usedCardsArray.length > 0) {
                    this._usedCards = usedCardsArray;

                    let usedCards = usedCardsArray.map((card) => {
                        return this._cards[card.id];
                    });

                    this.renderUsedCards(usedCards);
                    this.renderDrawerUsedCards(usedCards);
                    this.updateProgressBar();
                }
            });

            this._onReflectionMode = false;
            if (reflectionCardData.length > 0) {
                this._onReflectionMode = true;
                const flippedIds = flippedReflectionCards
                    ? Object.entries(flippedReflectionCards).map(([, value]) =>
                          Number(value.id),
                      )
                    : [];
                if (flippedIds.length === 3) {
                    this._isFinished = true;
                    if (this._isLeader) {
                        $(this.elms.finishCaseBtn).css("display", "flex");
                    }
                } else {
                    $(this.elms.finishCaseBtn).css("display", "none");
                }

                this.renderReflectionCards(reflectionCardData, flippedIds);

                $(this.elms.caseScenario).removeClass("has-overlay");
                getRoomCurrentCard(roomID).then((data) => {
                    const currentCardID = data.val();

                    if (currentCardID) {
                        this._currentCard = this._cards[currentCardID];
                        if (this._currentCard.template === "reflection") {
                            this.flipReflectionCard(currentCardID);
                        }
                        this.updateProgressBar();
                    }
                });

                return;
            }

            // Only proceed with other Firebase calls if no reflection cards
            getRoomCurrentCard(roomID).then((data) => {
                const currentCardID = data.val();
                if (currentCardID) {
                    this._currentCard = this._cards[currentCardID];
                    this.renderCardTemplate();
                    this.updateProgressBar();
                }
            });

            getRoomAvailableCards(roomID).then((data) => {
                const availableCardsData = data.val();
                const availableCardsArray = availableCardsData
                    ? Object.entries(availableCardsData).map(
                          ([key, value]) => ({
                              key,
                              ...value,
                          }),
                      )
                    : [];

                this._isStartingCard = false;
                if (
                    this._usedCards.length === 0 &&
                    availableCardsArray.length === 0
                ) {
                    this._isStartingCard = true;
                    this.updateAvailableCard(this._startingCard.id);
                    return;
                }

                this._availableCards = availableCardsArray;

                const latestCharacterCard = this._usedCards
                    .map((card) => this._cards[card.id])
                    .filter((card) => card.template === "character")
                    .pop();
                this._startingCard = latestCharacterCard
                    ? latestCharacterCard
                    : this._cards[this._data.starting_card];

                $(this.elms.breadcrumbCharacter)
                    .find(this.elms.backCardCharacterName)
                    .html(this._startingCard.title);
                $(this.elms.breadcrumbCharacter)
                    .find(this.elms.backCardDescription)
                    .html(this._startingCard.content);
                $(this.elms.breadcrumbCharacter)
                    .find(this.elms.backCardCharacterImage)
                    .attr("src", this._startingCard.templateData.illustration);
                $(this.elms.breadcrumbCharacter)
                    .find(this.elms.backCardCharacterProductivityNumber)
                    .html(this._startingCard.templateData.productivity_number);
                $(this.elms.breadcrumbCharacter)
                    .find(this.elms.backCardCharacterFeel)
                    .attr("src", this._startingCard.templateData.emotion);

                if (availableCardsArray.length === 1) {
                    const isStartingCard =
                        availableCardsArray[0].id === this._data.starting_card;
                    this._isStartingCard = isStartingCard;
                    if (isStartingCard) {
                        this.updateCurrentCard(availableCardsArray[0].id);
                    }
                }

                let availableCards = availableCardsArray.map((card) => {
                    return this._cards[card.id];
                });

                if (this._isStartingCard) return;

                this.renderAvailableCards(availableCards);
            });
        });

        return false;
    }

    maybeTeamAttributesChange() {
        const leaderID = getLeader();
        this._leader = leaderID;
        this._isLeader = leaderID === CONFIG.user.id;
        const leader = getPlayers().find((p) => p.userId === leaderID);

        $(this.elms.finishCaseBtn).css("display", "none");
        if (this._isLeader) {
            $(this.elms.headerTitle).css("display", "block");
            $(this.elms.headerLeader).css("display", "none");
            $(this.elms.headerSubtitle).css("display", "none");
            $(this.elms.leaveCaseBtn).prop("disabled", false);

            if ($(this.elms.caseScenarioOverlay).hasClass("is-option")) {
                $(this.elms.submitCard).css("display", "flex");
                $(this.elms.submitCard).prop("disabled", true);
            } else {
                $(this.elms.closeCard).css("display", "flex");
            }

            $(this.elms.templateStartingCardButton).css("display", "flex");
            if (this._isFinished) {
                $(this.elms.finishCaseBtn).css("display", "flex");
            }
        } else {
            $(this.elms.headerTitle).css("display", "none");
            $(this.elms.headerLeader).css("display", "block");
            $(this.elms.headerLeader).css("background-color", leader.colorHex);
            $(this.elms.headerSubtitle).css("display", "block");
            let headerSubtitle = "{player} player to pick a card to play";
            $(this.elms.headerSubtitle).text(
                headerSubtitle.replace("{player}", leader.name),
            );
            $(this.elms.leaveCaseBtn).prop("disabled", true);

            $(this.elms.templateStartingCardButton).css("display", "none");
        }
    }

    listenTeamAttributes() {
        const path = fb.teamAttributesPath;

        this.fbListeners.push(
            fb.onValue(path, this.maybeTeamAttributesChange.bind(this)),
        );
    }

    maybeRoomCardsChange(snapshot) {
        const data = snapshot.val();
        if (!data || !data.usedCards) return;

        const usedCardKeys = Object.keys(data.usedCards);
        const lastUsedCardKey = usedCardKeys[usedCardKeys.length - 1];

        const lastUsedCard = data.usedCards[lastUsedCardKey];
        const lastUsedCardId = lastUsedCard.id;

        $(`.caseScenario__card[data-card-id="${lastUsedCardId}"]`).remove();

        if (!data.currentCard) return;
        this._currentCard = this._cards[data.currentCard];

        // Update progress bar when cards change
        this.updateProgressBar();
    }

    listenRoomCards() {
        const path = fb.roomsPath;

        this.fbListeners.push(
            fb.onValue(
                `${path}/${this.roomId}`,
                this.maybeRoomCardsChange.bind(this),
            ),
        );
    }

    updateAvailableCard(cardID) {
        const roomID = this.roomId;

        const uniqueKey = fb.push().key;
        const card = { availableCards: { [uniqueKey]: { id: cardID } } };

        updateRoomCards(roomID, card);
        this._availableCards.push({
            key: uniqueKey,
            id: cardID,
        });
    }

    updateCurrentCard(cardID) {
        const roomID = this.roomId;

        updateRoomCards(roomID, {
            currentCard: cardID,
        });
    }

    updateUsedCard() {
        const roomID = this.roomId;
        const currentCard = this._currentCard;
        const cardID = this._currentCard.id;
        const isLeader = this._isLeader;

        if (isLeader && currentCard) {
            if (currentCard.template !== "score") {
                let drawnCards = [];
                let removedCards = [];

                if (
                    currentCard.template === "character" ||
                    currentCard.template === "text"
                ) {
                    drawnCards = currentCard.templateData.draw_cards;

                    if (
                        currentCard.template === "text" &&
                        currentCard.templateData.remove_cards
                    ) {
                        const removeCardIds =
                            currentCard.templateData.remove_cards;
                        removedCards =
                            removeCardIds.length > 0
                                ? removeCardIds
                                      .map((id) => {
                                          const foundCard =
                                              this._availableCards.find(
                                                  (card) => card.id === id,
                                              );
                                          return foundCard;
                                      })
                                      .filter((card) => card !== undefined)
                                : [];
                    }
                } else if (currentCard.template === "option") {
                    const $selectedOption = $(
                        ".options_list__item.is-selected",
                    );
                    drawnCards =
                        currentCard.templateData.option[
                            $selectedOption.data("option-index")
                        ].draw_cards;
                }

                if (currentCard.template === "option") {
                    const $selectedOption = $(
                        ".options_list__item.is-selected",
                    );
                    const removeCardIds =
                        currentCard.templateData.option[
                            $selectedOption.data("option-index")
                        ].remove_cards;

                    removedCards =
                        removeCardIds.length > 0
                            ? removeCardIds
                                  .map((id) => {
                                      const foundCard =
                                          this._availableCards.find(
                                              (card) => card.id === id,
                                          );
                                      return foundCard;
                                  })
                                  .filter((card) => card !== undefined)
                            : [];
                } else if (currentCard.template === "character") {
                    removedCards = this._availableCards;
                }

                // Find the used card to remove
                const foundCard = this._availableCards.find(
                    (card) => card.id === cardID,
                );
                const foundCardKey = foundCard.key;

                // Store the position of the used card if drawn cards exist
                if (drawnCards.length > 0) {
                    const $usedCard = $(
                        `.caseScenario__card[data-card-id="${cardID}"]`,
                    );
                    if ($usedCard.length) {
                        // Get rotation angle from transform
                        let rotate = 0;
                        const transform = $usedCard.css("transform");
                        if (transform && transform !== "none") {
                            // Extract rotation value from transform matrix
                            const values = transform
                                .split("(")[1]
                                .split(")")[0]
                                .split(",");
                            rotate = Math.round(
                                Math.atan2(
                                    Number(values[1]),
                                    Number(values[0]),
                                ) *
                                    (180 / Math.PI),
                            );
                        }

                        // Extract numeric values from CSS properties (removing 'px' or '%')
                        const topStr = $usedCard.css("top");
                        const leftStr = $usedCard.css("left");
                        let top = parseFloat(topStr);
                        let left = parseFloat(leftStr);

                        // Convert to percentage if the values are in pixels
                        if (topStr.indexOf("px") !== -1) {
                            top = (top / $(window).height()) * 100;
                        }
                        if (leftStr.indexOf("px") !== -1) {
                            left = (left / $(window).width()) * 100;
                        }

                        this._lastUsedCardPosition = {
                            top: top,
                            left: left,
                            rotate: rotate,
                        };
                    }
                }

                // Get existing used cards and available cards
                Promise.all([
                    getRoomUsedCards(roomID),
                    getRoomAvailableCards(roomID),
                ]).then(([usedCardsData, availableCardsData]) => {
                    const existingUsedCards = usedCardsData.val() || {};
                    const existingAvailableCards =
                        availableCardsData.val() || {};

                    // Create the update data object
                    const updateData = {
                        usedCards: {
                            ...existingUsedCards,
                            [fb.push().key]: { id: cardID },
                        },
                        currentCard: null,
                        availableCards: { ...existingAvailableCards },
                    };

                    // Add new cards from drawnCards
                    if (drawnCards.length > 0) {
                        drawnCards.forEach((id) => {
                            const newKey = fb.push().key;
                            updateData.availableCards[newKey] = { id: id };
                        });
                    }

                    // Remove the used card
                    if (foundCardKey) {
                        updateData.availableCards[foundCardKey] = null;
                    }

                    // Remove any additional cards that need to be removed
                    if (removedCards.length > 0) {
                        removedCards.forEach((card) => {
                            if (card && card.key) {
                                updateData.availableCards[card.key] = null;
                            }
                        });
                    }

                    // Update the room cards
                    updateRoomCards(roomID, updateData);
                    this.updateCurrentCard(null);
                });
            } else if (currentCard.template === "score") {
                const $reflectionBtn = $(
                    `.caseScenario__card[data-card-id="${cardID}"]`,
                ).find(this.elms.templateStartingCardButton);
                const reflectionsCardId = $reflectionBtn.attr(
                    "data-reflections-card-id",
                );
                const reflectionsCardIds = reflectionsCardId
                    .split(",")
                    .map((id) => Number(id.trim()));

                const reflectionData = {};
                reflectionsCardIds.forEach((id) => {
                    const newKey = fb.push().key;
                    reflectionData[newKey] = { id: id };
                });

                updateRoomCards(roomID, {
                    reflectionCards: reflectionData,
                    currentCard: null,
                });
            }
        }
    }

    renderDrawerUsedCards(cards) {
        if (cards.length > 6) {
            $(this.elms.showMoreUsedCards).css("display", "flex");
        }

        const $drawerItems = $(this.elms.drawerItems);
        const $drawerItemTemplate = $(this.elms.drawerItemTemplate);

        cards.forEach((card) => {
            if (!$drawerItems.find(`[data-card-id="${card.id}"]`).length) {
                const $item = $drawerItemTemplate.clone();
                $item.removeClass("is-template");
                $item.attr("data-card-id", card.id);
                $item.find("span").text(card.templateData?.tag_line || "");

                if (card.templateData.enable_hourglass) {
                    $item.addClass("has-hourglass");
                }

                if (card.color === "parent") {
                    $item.css({
                        outline: `1px solid ${
                            card.template === "character"
                                ? `hsl(${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).h
                                  }, ${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).s
                                  }%, ${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).l + 20
                                  }%)`
                                : this._roomData.room.background_color
                        }`,
                        "background-color":
                            card.template === "character"
                                ? this._roomData.room.background_color
                                : `hsl(${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).h
                                  }, ${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).s
                                  }%, ${
                                      hexToHsl(
                                          this._roomData.room.background_color,
                                      ).l + 20
                                  }%)`,
                    });
                } else {
                    $item.css({
                        outline: `1px solid ${
                            card.template === "character"
                                ? `hsl(${hexToHsl(card.color_hex).h}, ${
                                      hexToHsl(card.color_hex).s
                                  }%, ${hexToHsl(card.color_hex).l + 20}%)`
                                : card.color_hex
                        }`,
                        "background-color":
                            card.template === "character"
                                ? card.color_hex
                                : `hsl(${hexToHsl(card.color_hex).h}, ${
                                      hexToHsl(card.color_hex).s
                                  }%, ${hexToHsl(card.color_hex).l + 20}%)`,
                    });
                }

                $drawerItems.append($item);
            }
        });
    }

    renderUsedCards(cards) {
        const $breadcrumbItems = $(this.elms.breadcrumbItems);
        const $breadcrumbItemTemplate = $(this.elms.breadcrumbItemTemplate);

        // remove the first used card since it's the starting card
        cards = cards.slice(1);

        cards.forEach((card) => {
            if (!$breadcrumbItems.find(`[data-card-id="${card.id}"]`).length) {
                if (cards.length > 6) {
                    const $existingItems = $breadcrumbItems.children();
                    if ($existingItems.length >= 8) {
                        $existingItems.eq(1).remove();
                    }
                }

                const $item = $breadcrumbItemTemplate.clone();
                $item.removeClass("is-template");
                $item.attr("data-card-id", card.id);

                if (card.color === "parent") {
                    const parentColor = this._roomData.room.background_color;
                    $item.css({
                        outline: `1px solid ${
                            card.template === "character"
                                ? `hsl(${hexToHsl(parentColor).h}, ${
                                      hexToHsl(parentColor).s
                                  }%, ${hexToHsl(parentColor).l + 20}%)`
                                : parentColor
                        }`,
                        "background-color":
                            card.template === "character"
                                ? parentColor
                                : `hsl(${hexToHsl(parentColor).h}, ${
                                      hexToHsl(parentColor).s
                                  }%, ${hexToHsl(parentColor).l + 20}%)`,
                    });
                } else {
                    $item.css({
                        outline: `1px solid ${
                            card.template === "character"
                                ? `hsl(${hexToHsl(card.color_hex).h}, ${
                                      hexToHsl(card.color_hex).s
                                  }%, ${hexToHsl(card.color_hex).l + 20}%)`
                                : card.color_hex
                        }`,
                        "background-color":
                            card.template === "character"
                                ? card.color_hex
                                : `hsl(${hexToHsl(card.color_hex).h}, ${
                                      hexToHsl(card.color_hex).s
                                  }%, ${hexToHsl(card.color_hex).l + 20}%)`,
                    });
                }

                $item.find("span").text(card.templateData?.tag_line || "");

                if (card.templateData?.enable_hourglass) {
                    $item.addClass("has-hourglass");
                }

                const $existingItems = $breadcrumbItems.children();
                if ($existingItems.length >= 2) {
                    $item.insertBefore($existingItems.eq(-1));
                }
            }
        });
    }

    renderAvailableCards(cards) {
        const vh = window.innerHeight;
        const $card = $(this.elms.caseScenario);
        $card.removeClass("is-starting is-score is-reflection has-overlay");
        const $video = $(this.elms.video);
        $video.removeClass("is-playing").hide();

        // Remove cards that don't exist in the new cards array
        this.removeNonExistentCards(cards);

        let playedCards = 0;

        cards.forEach((card, index) => {
            // Skip cards that already exist
            if (this.cardExists(card.id)) {
                playedCards++;
                return;
            }

            const position = this.calculateCardPosition(index - playedCards);

            // If no position is available, skip this card
            if (!position) return;

            const scale = this.calculateCardScale(vh);

            switch (card.template) {
                case "character":
                    this.renderCharacterAvailableCard(
                        card,
                        position.top,
                        position.left,
                        position.rotate,
                        scale,
                        index,
                    );
                    break;
                case "option":
                    this.renderOptionAvailableCard(
                        card,
                        position.top,
                        position.left,
                        position.rotate,
                        scale,
                        index,
                    );
                    break;
                case "text":
                    this.renderTextAvailableCard(
                        card,
                        position.top,
                        position.left,
                        position.rotate,
                        scale,
                        index,
                    );
                    break;
                case "score":
                    this.renderScoreAvailableCard(
                        card,
                        position.top,
                        position.left,
                        position.rotate,
                        scale,
                        index,
                    );
                    break;
            }

            $(`.caseScenario__card[data-card-id="${card.id}"]`).addClass(
                "is-drawn",
            );
            $(`.caseScenario__card[data-card-id="${card.id}"]`).removeClass(
                "is-rendering",
            );
        });
    }

    removeNonExistentCards(cards) {
        $(".caseScenario__card:not(.is-template)").each(function () {
            const cardId = $(this).attr("data-card-id");
            if (cardId) {
                // Convert both values to strings to ensure proper comparison
                const cardIdString = String(cardId);
                const cardExists = cards.some(
                    (card) => String(card.id) === cardIdString,
                );

                if (!cardExists) {
                    $(this).remove();
                }
            }
        });
    }

    calculateGridDimensions() {
        const gridSize = 3;
        const spacing = 14;
        return { gridSize, spacing };
    }

    calculateGridPositions() {
        const positions = [];
        const spacing = 14;

        // Calculate all 9 positions in a 3x3 grid
        for (let row = 0; row < 3; row++) {
            for (let col = 0; col < 3; col++) {
                const rowOffset = row > 0 ? row * 12.5 : 0;
                const top = 20 + spacing * (row + 1) + rowOffset;
                const left = 20 + spacing * (col + 1);
                positions.push({ top, left });
            }
        }

        return positions;
    }

    getAvailablePositions() {
        const allPositions = this.calculateGridPositions();
        const $existingCards = $(
            ".caseScenario__card.is-drawn:not(.is-rendering):not(.is-template)",
        );
        const occupiedPositions = new Set();

        // Find which positions are occupied
        $existingCards.each(function () {
            const $card = $(this);
            const existingTop = parseFloat(
                $card.attr("style")?.match(/top:\s*([\d.]+)%/)?.[1] || "0",
            );
            const existingLeft = parseFloat(
                $card.attr("style")?.match(/left:\s*([\d.]+)%/)?.[1] || "0",
            );

            // Find the index of this position in allPositions
            const positionIndex = allPositions.findIndex(
                (pos) =>
                    Math.abs(pos.top - existingTop) < 0.1 &&
                    Math.abs(pos.left - existingLeft) < 0.1,
            );

            if (positionIndex !== -1) {
                occupiedPositions.add(positionIndex);
            }
        });

        // Create array of available position indices
        const availablePositions = [];
        for (let i = 0; i < allPositions.length; i++) {
            if (!occupiedPositions.has(i)) {
                availablePositions.push(i);
            }
        }

        return { allPositions, availablePositions };
    }

    calculateCardPosition(index) {
        const { allPositions, availablePositions } =
            this.getAvailablePositions();

        if (index >= availablePositions.length) {
            console.warn("No more available positions in the grid");
            return null;
        }

        // Get the position index from our available positions array
        const positionIndex = availablePositions[index];
        const position = allPositions[positionIndex];
        const rotate = Math.floor(Math.random() * 11) - 5;

        return { ...position, rotate };
    }

    calculateCardScale(vh) {
        return vh <= 600 ? 0.6375 : vh <= 768 ? 0.75 : 0.9;
    }

    cardExists(cardId) {
        return $(`.caseScenario__card[data-card-id="${cardId}"]`).length > 0;
    }

    createBaseCard(card, template, top, left, rotate, scale) {
        const $templateCard = $(
            this.elms[`templatePlayingCard${template}`],
        ).clone();
        $templateCard.removeClass("is-template");
        $templateCard.attr("data-card-id", card.id);

        if (Array.isArray(card.templateData.draw_cards)) {
            $templateCard.attr("data-draw-cards", card.templateData.draw_cards);
        }

        // Position cards at deck location
        const initialTransform = `translate(-50%, -50%) scale(${scale}) rotateX(-65deg) rotateY(-5deg) rotateZ(40deg)`;
        $templateCard.css({
            top: "95%",
            left: "95%",
            transform: initialTransform,
            opacity: 0,
        });

        $templateCard.attr("data-scale", scale);

        this.setCardContent($templateCard, card);

        return $templateCard;
    }

    animateCardToPosition($card, top, left, rotate, index = 0) {
        // Allow DOM to render the card in its initial position first
        setTimeout(() => {
            const scale = $card.attr("data-scale") || 1;
            const finalTransform = `translate(-50%, -50%) rotate(${rotate}deg) scale(${scale})`;

            $card.css({
                top: `${top}%`,
                left: `${left}%`,
                transform: finalTransform,
                opacity: 1,
            });
        }, 50 + index * 100); // Stagger the animations
    }

    setCardColors($card, card) {
        const backgroundColor =
            card.color === "parent"
                ? this._roomData.room.background_color
                : card.color_hex;

        // Set background colors immediately to both faces
        $card
            .find(this.elms.frontCard)
            .css("background-color", backgroundColor);
        $card.find(this.elms.backCard).css("background-color", backgroundColor);

        // Set additional background colors after element is in DOM
        setTimeout(() => {
            // Option card specific
            if ($card.hasClass("is-option")) {
                $card
                    .find(this.elms.backCardOptionListItem)
                    .css("background-color", backgroundColor);
            }

            // Text card specific
            if ($card.hasClass("is-text")) {
                $card
                    .find(this.elms.backCardTextAct)
                    .css("background-color", backgroundColor);
            }
        }, 0);
    }

    setCardContent($card, card) {
        $card.find(this.elms.frontCardNumber).text(card.number);
        $card.find(this.elms.frontCardTitle).text(card.title);
        $card.find(this.elms.backCardTitle).text(card.title);
        $card.find(this.elms.backCardDescription).html(card.content);

        const backgroundColor =
            card.color === "parent"
                ? this._roomData.room.background_color
                : card.color_hex;

        if (card.templateData.tag_line === "") {
            $card.find(this.elms.backCardTagLine).css("display", "none");
        } else {
            $card
                .find(this.elms.backCardTagLine)
                .css("display", "flex")
                .css("background-color", backgroundColor)
                .find("span")
                .text(card.templateData.tag_line);
        }

        if (card.templateData.enable_hourglass) {
            $card.addClass("has-hourglass");
        }
    }

    renderCharacterAvailableCard(card, top, left, rotate, scale, index = 0) {
        const $card = this.createBaseCard(
            card,
            "Character",
            top,
            left,
            rotate,
            scale,
        );

        // Add starting card class if this is the starting card
        if (card.id === this._data.starting_card) {
            $card.addClass("is-starting-card");
        }

        $card.find(this.elms.backCardCharacterName).text(card.title);
        $card
            .find(this.elms.backCardCharacterProductivityNumber)
            .text(card.templateData.productivity_number);
        $card
            .find(this.elms.backCardCharacterImage)
            .attr("src", card.templateData.illustration);
        $card
            .find(this.elms.backCardCharacterFeel)
            .attr("src", card.templateData.emotion);

        if (card.templateData.draw_cards.length > 0) {
            const $grid = $card.find(this.elms.backCardCharacterGrid).empty();
            card.templateData.draw_cards.forEach((item) => {
                const number = this._cards[item].number;
                $grid.append(`<li class="grid-card">${number}</li>`);
            });
        }

        $(this.elms.caseScenario).append($card);
        this.setCardColors($card, card);
        $card.addClass("is-rendering");
        this.animateCardToPosition($card, top, left, rotate, index);
    }

    renderOptionAvailableCard(card, top, left, rotate, scale, index = 0) {
        const $card = this.createBaseCard(
            card,
            "Option",
            top,
            left,
            rotate,
            scale,
        );

        const $optionList = $card.find(this.elms.backCardOptionList).empty();
        let optionAlphabet = "A";

        card.templateData.option.forEach((option, index) => {
            const cardNumbers =
                option.draw_cards && option.draw_cards.length > 0
                    ? option.draw_cards
                          .map((cardId) => {
                              const card = this._cards[cardId];
                              return card
                                  ? `<div class="card">${card.number}</div>`
                                  : "";
                          })
                          .join("")
                    : "";

            const optionList = `<li class="options_list__item" data-option-index="${index}" data-option-remove-cards="${option.remove_cards}">
                <span class="marker">${optionAlphabet}</span>
                <span class="answer">${option.answer_text}</span>
                ${cardNumbers}
            </li>`;

            $optionList.append(optionList);
            optionAlphabet = String.fromCharCode(
                optionAlphabet.charCodeAt(0) + 1,
            );
        });

        $(this.elms.caseScenario).append($card);
        this.setCardColors($card, card);
        $card.addClass("is-rendering");
        this.animateCardToPosition($card, top, left, rotate, index);
    }

    renderTextAvailableCard(card, top, left, rotate, scale, index = 0) {
        const $card = this.createBaseCard(
            card,
            "Text",
            top,
            left,
            rotate,
            scale,
        );

        if (card.templateData.draw_cards.length > 0) {
            $card.addClass("has-action");
            const $textAct = $card.find(this.elms.backCardTextAct);
            $textAct.find(".card").remove();

            card.templateData.draw_cards.forEach((item) => {
                const card = this._cards[item];
                $textAct.append(`<div class="card">${card.number}</div>`);
            });
        }

        $(this.elms.caseScenario).append($card);
        this.setCardColors($card, card);
        $card.addClass("is-rendering");
        this.animateCardToPosition($card, top, left, rotate, index);
    }

    renderScoreAvailableCard(card, top, left, rotate, scale, index = 0) {
        const $card = this.createBaseCard(
            card,
            "Text",
            top,
            left,
            rotate,
            scale,
        );
        $(this.elms.caseScenario).append($card);
        this.setCardColors($card, card);
        $card.addClass("is-rendering");
        this.animateCardToPosition($card, top, left, rotate, index);
    }

    renderCardTemplate() {
        const $card = $(this.elms.caseScenario);
        $card.removeClass("is-starting is-score is-reflection has-overlay");
        const $video = $(this.elms.video);
        $video.removeClass("is-playing").hide();
        const $overlay = $(".caseScenario__overlay__card");
        $(this.elms.caseScenarioOverlay).removeClass("is-option");

        const isStartingCard =
            this._currentCard.id === this._data.starting_card;
        if (isStartingCard) {
            $card.addClass("is-starting");
            $video.addClass("is-playing").show();

            // Remove any existing listener and add a single listener
            $video
                .off("ended", this._videoEndedHandler)
                .on("ended", this._videoEndedHandler);

            const startingCard = this._startingCard;
            const $templateStartingCard = $(
                this.elms.templateStartingCard,
            ).clone();
            $templateStartingCard.removeClass("is-template");
            $templateStartingCard.attr("data-card-id", startingCard.id);
            $templateStartingCard.addClass("is-starting-card");

            // Only append if card doesn't already exist
            const existingCard = $(
                `.caseScenario__card[data-card-id="${startingCard.id}"]`,
            );
            if (existingCard.length === 0) {
                // Set card colors if not using parent color
                if (startingCard.color !== "parent") {
                    $templateStartingCard
                        .find(
                            ".caseScenario__card--front, .caseScenario__card--back, .character_act",
                        )
                        .css("background-color", startingCard.color_hex);
                } else {
                    $templateStartingCard
                        .find(
                            ".caseScenario__card--front, .caseScenario__card--back, .character_act",
                        )
                        .css(
                            "background-color",
                            this._roomData.room.background_color,
                        );
                }

                // Set card content
                $templateStartingCard
                    .find(".caseScenario__card_number")
                    .text(startingCard.number);
                $templateStartingCard
                    .find(".caseScenario__card_title span")
                    .text(startingCard.title);
                $templateStartingCard
                    .find(".caseScenario__card_character__image")
                    .attr("src", startingCard.templateData.illustration);
                $templateStartingCard
                    .find(".caseScenario__card_character__name")
                    .text(startingCard.title);
                $templateStartingCard
                    .find(".caseScenario__card_character__productivity")
                    .text(startingCard.templateData.productivity_number);
                $templateStartingCard
                    .find(".caseScenario__card_character__feel")
                    .attr("src", startingCard.templateData.emotion);

                // Populate grid cards
                const $grid = $templateStartingCard
                    .find(".caseScenario__card_character__grid")
                    .empty();
                startingCard.templateData.draw_cards.forEach((item) => {
                    const number = this._cards[item].number;
                    $grid.append(`<li class="grid-card">${number}</li>`);
                });

                // Set card description
                $templateStartingCard
                    .find(".caseScenario__card_description")
                    .html(startingCard.content);

                $templateStartingCard
                    .find(this.elms.templateStartingCardButton)
                    .css("display", "none");

                $(this.elms.caseScenario).append($templateStartingCard);
            } else {
                // when starting card is flipped
                existingCard.addClass("is-flipped");
                $overlay.empty();

                setTimeout(() => {
                    const $clonedCard = existingCard.clone();
                    $clonedCard.addClass("is-in-overlay is-starting-card");
                    $templateStartingCard
                        .find(this.elms.templateStartingCardButton)
                        .css("display", "none");

                    if (
                        $overlay.find(".caseScenario__card.is-in-overlay")
                            .length === 0
                    ) {
                        $overlay.append($clonedCard);
                        $(this.elms.caseScenario).addClass("has-overlay");
                        $(".caseScenario__overlay__btn").removeAttr("style");
                        if (!this._isLeader) {
                            $(".caseScenario__overlay__btn").css(
                                "display",
                                "none",
                            );
                        }
                    }
                }, 500);
            }
        } else {
            const card = this._currentCard;
            const cardID = card.id;

            // Wait for the next tick to ensure DOM is updated
            setTimeout(() => {
                if (card.template !== "score") {
                    const $card = $(
                        `.caseScenario__card[data-card-id="${cardID}"]`,
                    );

                    $card.addClass("is-flipped");
                    $overlay.empty();

                    setTimeout(() => {
                        const $clonedCard = $card.clone();
                        $clonedCard.addClass("is-in-overlay");
                        if (
                            $overlay.find(".caseScenario__card.is-in-overlay")
                                .length === 0
                        ) {
                            $overlay.append($clonedCard);
                            $(this.elms.caseScenario).addClass("has-overlay");
                            if (card.template === "option") {
                                $(this.elms.caseScenarioOverlay).addClass(
                                    "is-option",
                                );
                                $(this.elms.submitCard).prop("disabled", true);
                            }

                            if (
                                card.template === "text" &&
                                card.templateData.draw_cards.length > 0
                            ) {
                                $clonedCard.addClass("has-action");
                            }

                            $(".caseScenario__overlay__btn").removeAttr(
                                "style",
                            );
                            if (!this._isLeader) {
                                $(".caseScenario__overlay__btn").css(
                                    "display",
                                    "none",
                                );
                            }
                        }
                    }, 500);
                } else if (card.template === "score") {
                    this.openScoreCard();
                }
            }, 0);
        }
    }

    renderReflectionCards(cards, flippedIds) {
        const vh = window.innerHeight;
        const $card = $(this.elms.caseScenario);
        $card.removeClass("is-score").addClass("is-reflection");

        // Since we know there are always 3 cards, we can use fixed spacing
        const spacing = 20; // Fixed spacing between cards
        const centerPosition = 50; // Center of the container

        cards.forEach((card, index) => {
            const existingCard = $(
                `.caseScenario__card[data-card-id="${card.id}"]`,
            );
            if (existingCard.length > 0) {
                if (flippedIds.includes(card.id)) {
                    existingCard.addClass("is-flipped");
                }
                return;
            }

            const $templateCard = $(this.elms.templateReflectionCard).clone();
            $templateCard.removeClass("is-template");
            $templateCard.attr("data-card-id", card.id);

            if (flippedIds.includes(card.id)) {
                $templateCard.addClass("is-flipped");
            }

            // Calculate position for 3 cards centered horizontally
            const left = centerPosition + (index - 1) * spacing;
            const rotate = index % 2 === 0 ? 5 : -5; // Alternate rotation
            const scale = vh <= 600 ? 0.75 : vh <= 768 ? 0.85 : 1;

            $templateCard.attr("data-scale", scale);

            $templateCard.css({
                top: "95%",
                left: "95%",
                transform: `translate(-50%, -50%) scale(${scale}) rotateX(-65deg) rotateY(-5deg) rotateZ(40deg)`,
                opacity: 0,
            });

            if (card.color === "parent") {
                $templateCard
                    .find(this.elms.frontCard)
                    .css(
                        "background-color",
                        this._roomData.room.background_color,
                    );
            } else {
                $templateCard
                    .find(this.elms.frontCard)
                    .css("background-color", card.color_hex);
            }

            $templateCard.find(this.elms.frontCardNumber).text(card.number);
            $templateCard.find(this.elms.frontCardTitle).text(card.title);

            $templateCard
                .find(this.elms.reflectionCardTop)
                .find(this.elms.reflectionCardQuestion)
                .text(card.templateData.text_in_game);

            $templateCard
                .find(this.elms.reflectionCardBottom)
                .find(this.elms.reflectionCardQuestion)
                .text(card.templateData.text_real_live);

            $card.append($templateCard);

            $card.addClass("is-rendering");

            setTimeout(() => {
                this.animateCardToPosition(
                    $templateCard,
                    50,
                    left,
                    rotate,
                    index,
                );
            }, index * 100); // Stagger the animations
        });
    }

    onPlayCard() {
        const startingCardId = this._data.starting_card;
        this.updateCurrentCard(startingCardId);
    }

    onUseCard() {
        this.updateUsedCard();

        const leaderID = getLeader();
        const players = getPlayers();

        const currentLeaderIndex = players.findIndex(
            (player) => player.userId === leaderID,
        );

        // Find next online player
        let nextOnlineLeader = null;
        for (let i = 1; i <= players.length; i++) {
            const nextIndex = (currentLeaderIndex + i) % players.length;
            const potentialLeader = players[nextIndex];
            if (potentialLeader.isOnline) {
                nextOnlineLeader = potentialLeader;
                break;
            }
        }

        if (nextOnlineLeader) {
            GameLogic.setNextLeader(nextOnlineLeader.userId);
        }

        // Reset the flag after handling the card (it will only be true for the next render cycle)
        setTimeout(() => {
            this._isFromStartingCardButton = false;
        }, 0);
    }

    onClickCard(e) {
        if (!this._isLeader) return;

        const $target = $(e.currentTarget);
        const $card = $target.closest(".caseScenario__card");

        $(".caseScenario__card").removeClass("is-clicked");

        if (
            $card.hasClass("is-reflection") ||
            $card.hasClass("playing-card") ||
            $card.hasClass("starting-card")
        ) {
            $card.addClass("is-clicked");
        }
    }

    onFlipCard(e) {
        if (!this._isLeader) return;

        const $target = $(e.currentTarget);
        const $card = $target.closest(".caseScenario__card");
        const cardID = $card.attr("data-card-id");

        if ($card.hasClass("is-reflection")) {
            this.updateCurrentCard(cardID);
            const roomID = this.roomId;

            getRoomReflectionData(roomID).then((data) => {
                const existingFlippedCards =
                    data.flippedReflectionCards.val() || {};

                // Add new card to existing ones
                const uniqueKey = fb.push().key;
                const updatedFlippedCards = {
                    ...existingFlippedCards,
                    [uniqueKey]: { id: cardID },
                };

                // Update with all cards
                updateRoomCards(roomID, {
                    flippedReflectionCards: updatedFlippedCards,
                });
            });
        } else if ($card.hasClass("starting-card")) {
            this.updateCurrentCard(cardID);
        } else {
            this.updateCurrentCard(cardID);
        }
    }

    flipReflectionCard(cardID) {
        const $card = $(`.caseScenario__card[data-card-id="${cardID}"]`);
        $card.addClass("is-flipped");

        setTimeout(() => {
            const $overlay = $(".caseScenario__overlay__card");
            const $clonedCard = $card.clone();

            $clonedCard.addClass("is-in-overlay");
            $overlay.empty();

            if (
                $overlay.find(".caseScenario__card.is-in-overlay").length === 0
            ) {
                $overlay.append($clonedCard);
                $(this.elms.caseScenario).addClass("has-overlay");
            }

            $(".caseScenario__overlay__btn").removeAttr("style");
            if (!this._isLeader) {
                $(".caseScenario__overlay__btn").css("display", "none");
            }
        }, 500);
    }

    renderBreadcrumb(card) {
        const $curtainCard = $(this.elms.curtainCard);
        const $playingCard = $curtainCard.find(this.elms.playingCard);

        // Reset classes and prepare card
        $playingCard.removeClass(
            "is-character is-option is-text has-hourglass has-action",
        );
        $playingCard.addClass(`is-${card.template}`);

        // Add starting card class if this is the starting card
        if (card.id === this._data.starting_card) {
            $playingCard.addClass("is-starting-card");
        }

        // Set common properties
        $playingCard.find(this.elms.backCardTitle).text(card.title);
        $playingCard.find(this.elms.backCardDescription).html(card.content);

        // Set colors
        const backgroundColor =
            card.color === "parent"
                ? this._roomData.room.background_color
                : card.color_hex;

        // Apply background color to all necessary elements
        $playingCard
            .find(this.elms.backCard)
            .css("background-color", backgroundColor);
        $playingCard
            .find(this.elms.frontCard)
            .css("background-color", backgroundColor);

        // Handle tag line
        const $tagLine = $playingCard.find(this.elms.backCardTagLine);
        if (card.templateData.tag_line === "") {
            $tagLine.css("display", "none");
        } else {
            $tagLine
                .css("display", "flex")
                .find("span")
                .text(card.templateData.tag_line);
        }

        // Handle hourglass
        if (card.templateData.enable_hourglass) {
            $playingCard.addClass("has-hourglass");
        }

        // Handle specific template types
        switch (card.template) {
            case "character":
                this.renderCharacterCard(card, $playingCard);
                break;
            case "option":
                this.renderOptionCard(card, $playingCard, backgroundColor);
                break;
            case "text":
                this.renderTextCard(card, $playingCard, backgroundColor);
                break;
        }
    }

    renderCharacterCard(card, $playingCard) {
        $playingCard.find(this.elms.backCardCharacterName).text(card.title);

        $playingCard
            .find(this.elms.backCardCharacterProductivityNumber)
            .text(card.templateData.productivity_number);
        $playingCard
            .find(this.elms.backCardCharacterImage)
            .attr("src", card.templateData.illustration);
        $playingCard
            .find(this.elms.backCardCharacterFeel)
            .attr("src", card.templateData.emotion);

        if (card.templateData.draw_cards.length > 0) {
            const $grid = $playingCard
                .find(this.elms.backCardCharacterGrid)
                .empty();
            card.templateData.draw_cards.forEach((item) => {
                const number = this._cards[item].number;
                $grid.append(`<li class="grid-card">${number}</li>`);
            });
        }
    }

    renderOptionCard(card, $playingCard, backgroundColor) {
        const $optionList = $playingCard
            .find(this.elms.backCardOptionList)
            .empty();
        let optionAlphabet = "A";

        card.templateData.option.forEach((option, index) => {
            const cardNumbers =
                option.draw_cards && option.draw_cards.length > 0
                    ? option.draw_cards
                          .map((cardId) => {
                              const card = this._cards[cardId];
                              return card
                                  ? `<div class="card">${card.number}</div>`
                                  : "";
                          })
                          .join("")
                    : "";

            const optionList = `<li class="options_list__item" data-option-index="${index}" data-option-remove-cards="${option.remove_cards}">
                <span class="marker">${optionAlphabet}</span>
                <span class="answer">${option.answer_text}</span>
                ${cardNumbers}
            </li>`;

            $optionList.append(optionList);
            optionAlphabet = String.fromCharCode(
                optionAlphabet.charCodeAt(0) + 1,
            );
        });

        $playingCard
            .find(this.elms.backCardOptionListItem)
            .css("background-color", backgroundColor);
    }

    renderTextCard(card, $playingCard, backgroundColor) {
        if (card.templateData.draw_cards.length > 0) {
            $playingCard.addClass("has-action");
            const $textAct = $playingCard.find(this.elms.backCardTextAct);
            $textAct.find(".card").remove();

            card.templateData.draw_cards.forEach((item) => {
                const card = this._cards[item];
                $textAct.append(`<div class="card">${card.number}</div>`);
            });
        }

        $playingCard
            .find(this.elms.backCardTextAct)
            .css("background-color", backgroundColor);
    }

    onClickBreadcrumbItem(e) {
        const $target = $(e.currentTarget);
        const cardID = $target.attr("data-card-id");
        const highlightedCard = this._cards[cardID];

        $(this.elms.caseScenario).addClass("has-breadcrumb-overlay");
        $(this.elms.curtainCard).addClass("is-open");

        this.renderBreadcrumb(highlightedCard);
    }

    onCloseBreadcrumbView() {
        $(this.elms.caseScenario).removeClass("has-breadcrumb-overlay");
        $(this.elms.curtainCard).removeClass("is-open");
    }

    openScoreCard() {
        const card = this._currentCard;
        const usedCards = this._usedCards;

        let totalHourglass = 0;
        usedCards.forEach((usedCard) => {
            const card = this._cards[usedCard.id];
            if (
                card &&
                card.templateData &&
                card.templateData.enable_hourglass === true
            ) {
                totalHourglass++;
            }
        });

        let hourglassSummary;
        if (totalHourglass <= 4) {
            hourglassSummary =
                card.templateData.hourglass_summary.low_hourglasses;
        } else if (totalHourglass <= 8) {
            hourglassSummary =
                card.templateData.hourglass_summary.medium_hourglasses;
        } else {
            hourglassSummary =
                card.templateData.hourglass_summary.high_hourglasses;
        }

        const $card = $(this.elms.caseScenario);
        $card.addClass("is-score");

        const $templateCard = $(this.elms.templateScoreCard).clone();
        $templateCard.removeClass("is-template");
        $templateCard.attr("data-card-id", card.id);

        if (card.color === "parent") {
            $templateCard
                .find(this.elms.backCard)
                .css("background-color", this._roomData.room.background_color);
        } else {
            $templateCard
                .find(this.elms.backCard)
                .css("background-color", card.color_hex);
        }

        $templateCard.find(this.elms.scoreCardTitle).text(card.title);
        $templateCard
            .find(this.elms.scoreCardTop)
            .append(card.templateData.ending_summary);
        $templateCard.find(this.elms.scoreCardBottom).append(hourglassSummary);

        $templateCard
            .find(this.elms.templateStartingCardButton)
            .attr(
                "data-reflections-card-id",
                card.templateData.draw_reflection_cards,
            );

        $card.append($templateCard);
    }

    onSubmitCard(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);
        const reflectionsCardId = $target.attr("data-reflections-card-id");
        if (reflectionsCardId) return;

        this.onUseCard();
    }

    onCloseCard(e) {
        e.preventDefault();

        const $target = $(e.currentTarget);
        const reflectionsCardId = $target.attr("data-reflections-card-id");
        if (reflectionsCardId) return;

        const $overlay = $(".caseScenario__overlay__card");
        const $overlayCard = $overlay.find(".caseScenario__card");
        if ($overlayCard.hasClass("is-reflection")) {
            $(this.elms.caseScenario).removeClass("has-overlay");
            this.updateCurrentCard(null);
            return;
        } else if ($overlayCard.hasClass("starting-card")) {
            $(this.elms.caseScenario).removeClass("has-overlay");
            this._isFromStartingCardButton = true;
        }

        this.onUseCard();
    }

    onOptionClick(e) {
        if (!this._isLeader) return;

        const $target = $(e.currentTarget);
        $(".options_list__item").removeClass("is-selected");
        $target.addClass("is-selected");
        $(this.elms.submitCard).removeAttr("disabled");
        const $parent = $target.closest(".caseScenario__card");

        const removeCardsStr = String($target.data("option-remove-cards"));
        const removeCards = removeCardsStr ? removeCardsStr.split(",") : [];

        $parent.removeClass("has-action");
        if (removeCards && removeCards.length > 0) {
            $parent.addClass("has-action");
        }
    }

    onShowBreadcrumbCharacter() {
        const $card = $(this.elms.breadcrumbCard);
        const $container = $(this.elms.breadcrumbContainer);

        $card.addClass("is-full");
        $container.addClass("card-is-displayed");
    }

    onHideBreadcrumbCharacter() {
        const $card = $(this.elms.breadcrumbCard);
        const $container = $(this.elms.breadcrumbContainer);

        $card.removeClass("is-full");
        $container.removeClass("card-is-displayed");
    }

    onShowMoreUsedCards() {
        const $drawer = $(".caseScenario__drawer");
        $drawer.addClass("is-open");
        const $drawerItems = $(this.elms.drawerItems);
        $drawerItems.scrollTop($drawerItems[0].scrollHeight);
        $(this.elms.curtainCard).removeClass("is-open");
        $(this.elms.caseScenario).removeClass("has-breadcrumb-overlay");
    }

    onClickDrawerItem(e) {
        const $target = $(e.currentTarget);
        const cardID = $target.attr("data-card-id");
        const highlightedCard = this._cards[cardID];

        $(this.elms.caseScenario).addClass("has-breadcrumb-overlay");
        $(this.elms.curtainCard).addClass("is-open");

        this.renderBreadcrumb(highlightedCard);
    }

    onCloseDrawer() {
        const $drawer = $(".caseScenario__drawer");
        $drawer.removeClass("is-open");
        $(this.elms.curtainCard).removeClass("is-open");
        $(this.elms.caseScenario).removeClass("has-breadcrumb-overlay");
    }

    onFinishCase(e) {
        e.preventDefault();

        const roomID = this.roomId;
        const completed = "is-status-completed";
        const mainroomID = CONFIG.game.mainrooms[0].id;

        maybeUpdateRoomStatus(roomID, completed);
        removeSelectedCase();
        GameLogic.goToPage(mainroomID);
    }

    onVideoEnded() {
        const $video = $(this.elms.video);
        $video.removeClass("is-playing").fadeOut(300);
    }

    updateProgressBar() {
        // Reset all segments
        $(".progress-segment").removeClass("is-active is-completed");

        // If no phases, return early
        if (this._totalPhases === 0) return;

        // Handle reflection mode or score card completion
        if (
            (this._currentCard && this._currentCard.template === "score") ||
            this._onReflectionMode
        ) {
            $(".progress-segment").addClass("is-completed");
            return;
        }

        // Determine the current phase based on used cards and current card
        let currentPhase = this.determineCurrentPhase();

        // Update progress for each phase
        Object.keys(this._phases).forEach((phaseId) => {
            const phaseNumber = parseInt(phaseId);
            const $segment = $(`.progress-segment[data-phase="${phaseId}"]`);

            if (phaseNumber < currentPhase) {
                // Previous phases - make them full
                $segment.addClass("is-completed");
            } else if (phaseNumber === currentPhase) {
                // Current phase - calculate percentage based on used cards
                $segment.addClass("is-active");
                this.calculatePhaseProgress(phaseId, $segment);
            }
            // Future phases remain inactive (default state)
        });
    }

    determineCurrentPhase() {
        // If there's a current card, use its phase
        if (this._currentCard && this._currentCard.phase) {
            return parseInt(this._currentCard.phase);
        }

        // If no current card, determine phase based on used cards
        if (this._usedCards && this._usedCards.length > 0) {
            // Get all phase IDs and sort them by their index in the phases object
            const phaseIds = Object.keys(this._phases);
            let latestPhaseIndex = 0;
            let latestPhaseId = String(phaseIds[0] || 1);

            this._usedCards.forEach((usedCard) => {
                const card = this._cards[usedCard.id];
                if (card && card.phase) {
                    const cardPhaseId = String(card.phase);
                    const phaseIndex = phaseIds.indexOf(cardPhaseId);

                    // If this phase has a higher index than our current latest, update it
                    if (phaseIndex > latestPhaseIndex) {
                        latestPhaseIndex = phaseIndex;
                        latestPhaseId = cardPhaseId;
                    }
                }
            });

            return parseInt(latestPhaseId);
        }

        // Default to starting card phase if no used cards
        return this._startingCard.phase || 1;
    }

    calculatePhaseProgress(phaseId, $segment) {
        const phaseCards = this._phases[phaseId] || [];
        const totalCardsInPhase = phaseCards.length;

        if (totalCardsInPhase === 0) return;

        // Count used cards in this phase
        const usedCardsInPhase = this._usedCards.filter((usedCard) => {
            const card = this._cards[usedCard.id];
            return card && String(card.phase) === String(phaseId);
        }).length;

        // Calculate percentage (0-100)
        const percentage = Math.min(
            (usedCardsInPhase / totalCardsInPhase) * 100,
            100,
        );

        // Update the segment fill
        $segment.find(".segment-fill").css("width", `${percentage}%`);
    }

    renderLeaveCasePopup() {
        const $popup = $(this.elms.leavePopup);
        const $popupButton = $(this.elms.leaveCaseBtn);
        const $popupTitle = $popup.find(".caseScenario__leave-popup__title");
        const $popupYesButton = $popup.find(".js-leave-popup-yes");
        const $popupNoButton = $popup.find(".js-leave-popup-no");

        $popupButton.find("span").text(CONFIG.game.leave_case_popup.button_text);
        $popupTitle.text(CONFIG.game.leave_case_popup.content_text);
        $popupYesButton
            .find("span")
            .text(CONFIG.game.leave_case_popup.confirm_button_text);
        $popupNoButton
            .find("span")
            .text(CONFIG.game.leave_case_popup.cancel_button_text);
    }

    onLeaveCase(e) {
        e.preventDefault();
        $(this.elms.leavePopup).addClass("is-open");
    }

    onCloseLeavePopup(e) {
        e.preventDefault();
        $(this.elms.leavePopup).removeClass("is-open");
    }

    onConfirmLeaveCase(e) {
        e.preventDefault();

        const mainroomID = CONFIG.game.mainrooms[0].id;
        GameLogic.goToPage(mainroomID);
    }
}
